// extracted by mini-css-extract-plugin
export default {"itemWrapper":"X99K4lCLEq","itemWrapper_prerender":"zHq_g_a6cw","endOfListSpacing":"mRMz0Lc4hP"};